<template lang="pug">
  self-layout
    template(#resume)
      self-resume
    template(#feed)
      self-feed(v-if="routeState.isMe || routeState.myFollow")
      illustration-state(
        v-else
        :illustration="illustration"
        body="Abonnez vous pour en voir plus")
</template>

<script>
import { page, injectRouteState } from '@iez/core'
import { mdiAccountCircle } from '@mdi/js'
import { computed } from '@vue/composition-api'
import data from '@iez/lib/data/'
import user from '@iez/lib/user/'
import { routeCurrent } from '@iez/core/router/'
import illustration from '@iez/illustrations/SocialInteraction'

import IllustrationState from '@iez/components/illustration-state/'
import SelfLayout from './layout/'
import SelfResume from './resume/'
import SelfFeed from './feed/'

const route = {
  name: 'Profile',
  path: '/profile/:id?'
  // get = [heroId]
}

page.bottomNavigation.add({
  route: {
    ...route,
    path: '/profile'
  },
  icon: mdiAccountCircle,
  position: 4
})

export default {
  ...route,

  components: {
    SelfLayout,
    SelfResume,
    SelfFeed,
    IllustrationState
  },

  setup () {
    const isMe = !routeCurrent.params.id
    const userId = isMe ? user.id : routeCurrent.params.id

    const routeState = injectRouteState({
      shouldReset: true,
      payload: {
        hasScrolledName: false,
        type: computed(
          () => routeState.user?.isAdmin
            ? 'admin'
              : routeState.user?.association?.id
                ? 'association'
                : 'viewer'
        ),
        typeLabel: computed(() => ({
          admin: `Officiel`,
          association: `Asso`,
          viewer: `Viewer`
        }[routeState.type])),
        isMe,
        userId,
        followsUsersFollowers: data.get({
          root: `followsUsers`,
          one: true,
          request: {
            where: {
              _and: {
                followedId: {
                  _eq: userId
                },
                followerId: {
                  _eq: user.id
                }
              }
            }
          },
          fields: [
            `id`
          ]
        }),
        myFollow: computed(
          () =>
            !routeState.isMe &&
            routeState.followsUsersFollowers
        ),
        user: data.get({
          root: 'users',
          one: true,
          request: {
            where: {
              id: {
                _eq: userId
              }
            }
          },
          fields: [
            'id',
            'phoneNumber',
            'isAdmin',
            `description`,
            `link`,
            'name', {
              viewsAds_aggregate: [{
                aggregate: [
                  `count`
                ]
              }],
              image: [
                `id`,
                `src`,
                `srcLazy`
              ],
              followsUsersFollowers_aggregate: [{
                aggregate: [
                  `count`
                ]
              }],
              association: [
                `id`, {
                  viewsAds_aggregate: [{
                    aggregate: [
                      `count`
                    ]
                  }]
                }
              ],
              likesPosts: [
                `id`,
                `postId`
              ],
              posts: [
                `id`
              ]
            }
          ]
        })
      }
    })

    page.topBar.set(
      () => !routeState.isMe
        ? {
          color: `transparent`,
          title: routeState.user?.name
        } : null
    )

    return {
      routeState,
      illustration
    }
  }
}
</script>
